/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MongoDataCollectionDto } from '../../models/mongo-data-collection-dto';

export interface GetMongoDataCollections$Params {
  'X-API-Version'?: string;
}

export function getMongoDataCollections(http: HttpClient, rootUrl: string, params?: GetMongoDataCollections$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MongoDataCollectionDto>>> {
  const rb = new RequestBuilder(rootUrl, getMongoDataCollections.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MongoDataCollectionDto>>;
    })
  );
}

getMongoDataCollections.PATH = '/api/mongo-data/collections';
